import { useEffect, useState, type ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { AreaPanel, type Submission } from './ReviewPanels.js';

/**
 * M10 L10.06 — Area Validation (§12).
 *
 * The area as the painter measured it and the job's quantity: every change
 * made to it with the figure before and after, and - while the reader holds
 * the job's open level - the boxes to correct it (owner, 25-26 Oct). The same
 * panel the review screen shows.
 */
export function QualityAreaValidationPage(): ReactNode {
  const { reviewId = '' } = useParams<{ reviewId: string }>();
  const { token } = useAuth();
  const { t } = useTranslation();
  const [submission, setSubmission] = useState<Submission | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<Submission>(`/v1/quality/reviews/${reviewId}/submission`, { token })
      .then((s) => { if (alive) setSubmission(s); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [reviewId, token]);

  return (
    <main aria-label="quality-area-validation">
      <p style={{ marginBottom: 8 }}><Link to={`/quality/review/${reviewId}`}>{t('quality.common.back')}</Link></p>
      {error && <p role="alert" style={{ color: 'var(--color-danger)' }}>{error}</p>}
      {submission ? <AreaPanel submission={submission} /> : !error && <p>{t('common.loading')}</p>}
    </main>
  );
}
